//#region src/generated/schemas.gen.ts
var e = {
	type: "string",
	enum: ["VASCO"],
	description: "The fulfilment platform."
}, t = {
	type: "string",
	enum: ["status"]
}, n = {
	type: "string",
	enum: ["ASC", "DESC"],
	description: "The sort direction."
}, r = {
	type: "string",
	enum: [
		"CANCELED",
		"COMPLETED",
		"CONCEPT",
		"PARTIALLY_RECEIVED",
		"REGISTERED",
		"REGISTRATION_REQUESTED"
	],
	description: "The status of the purchase order."
}, i = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["CANCELED"]
		},
		canceledAt: {
			type: "string",
			format: "date-time",
			description: "The cancellation date of the purchase order."
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"canceledAt",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"lines"
	]
}, a = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["COMPLETED"]
		},
		completedAt: {
			type: "string",
			format: "date-time",
			description: "The completion date of the purchase order."
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		},
		receipts: {
			type: "array",
			items: {
				type: "object",
				properties: {
					addedAt: {
						type: "string",
						format: "date-time",
						description: "The moment when the receipt was added to the purchase order."
					},
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a receipt."
					},
					quantity: {
						anyOf: [{
							type: "integer",
							exclusiveMaximum: 0,
							minimum: -9007199254740991
						}, {
							type: "integer",
							exclusiveMinimum: 0,
							maximum: 9007199254740991
						}],
						description: "The quantity of the received product."
					}
				},
				required: [
					"addedAt",
					"product",
					"quantity"
				],
				description: "A receipt of the purchase order."
			},
			minItems: 1,
			maxItems: 1e3,
			description: "The receipts of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"completedAt",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"externalReference",
		"lines",
		"receipts"
	]
}, o = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["CONCEPT"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status"
	]
}, s = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["PARTIALLY_RECEIVED"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		},
		receipts: {
			type: "array",
			items: {
				type: "object",
				properties: {
					addedAt: {
						type: "string",
						format: "date-time",
						description: "The moment when the receipt was added to the purchase order."
					},
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a receipt."
					},
					quantity: {
						anyOf: [{
							type: "integer",
							exclusiveMaximum: 0,
							minimum: -9007199254740991
						}, {
							type: "integer",
							exclusiveMinimum: 0,
							maximum: 9007199254740991
						}],
						description: "The quantity of the received product."
					}
				},
				required: [
					"addedAt",
					"product",
					"quantity"
				],
				description: "A receipt of the purchase order."
			},
			minItems: 1,
			maxItems: 1e3,
			description: "The receipts of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"externalReference",
		"lines",
		"receipts"
	]
}, c = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["REGISTERED"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"externalReference",
		"lines"
	]
}, l = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["REGISTRATION_REQUESTED"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"lines"
	]
}, u = {
	oneOf: [
		{ $ref: "#/components/schemas/CanceledPurchaseOrder" },
		{ $ref: "#/components/schemas/CompletedPurchaseOrder" },
		{ $ref: "#/components/schemas/ConceptPurchaseOrder" },
		{ $ref: "#/components/schemas/PartiallyReceivedPurchaseOrder" },
		{ $ref: "#/components/schemas/RegisteredPurchaseOrder" },
		{ $ref: "#/components/schemas/RegistrationRequestedPurchaseOrder" }
	],
	discriminator: {
		propertyName: "status",
		mapping: {
			CANCELED: "#/components/schemas/CanceledPurchaseOrder",
			COMPLETED: "#/components/schemas/CompletedPurchaseOrder",
			CONCEPT: "#/components/schemas/ConceptPurchaseOrder",
			PARTIALLY_RECEIVED: "#/components/schemas/PartiallyReceivedPurchaseOrder",
			REGISTERED: "#/components/schemas/RegisteredPurchaseOrder",
			REGISTRATION_REQUESTED: "#/components/schemas/RegistrationRequestedPurchaseOrder"
		}
	}
}, d = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, f = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, p = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:not-found"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [404],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] }, m = { VASCO: "VASCO" }, h = { STATUS: "status" }, g = {
	ASC: "ASC",
	DESC: "DESC"
}, _ = {
	CANCELED: "CANCELED",
	COMPLETED: "COMPLETED",
	CONCEPT: "CONCEPT",
	PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
	REGISTERED: "REGISTERED",
	REGISTRATION_REQUESTED: "REGISTRATION_REQUESTED"
}, v = {
	Container: "CONTAINER",
	Pallet: "PALLET",
	Package: "PACKAGE"
}, y = (e) => e.status === "CONCEPT", b = (e) => e.status === "PARTIALLY_RECEIVED", x = (e) => e.status === "REGISTRATION_REQUESTED", S = (e) => e.status === "REGISTERED", C = (e) => e.status === "COMPLETED", w = (e) => e.status === "CANCELED", T = (e) => y(e) || S(e) || x(e);
//#endregion
export { r as C, n as E, u as S, l as T, s as _, S as a, d as b, v as c, _ as d, g as f, e as g, o as h, b as i, m as l, a as m, C as n, x as o, i as p, y as r, T as s, w as t, h as u, f as v, c as w, t as x, p as y };
